'use client';
var IDENT = "Link";
var defaultProps = {
    underline: "none",
    weight: "regular",
    transitionDuration: 200,
    color: "info"
};

export { IDENT, defaultProps };
